import React from 'react';
import { ShieldCheck, Clock, BadgeDollarSign, ThumbsUp } from 'lucide-react';
const REASONS = [{
  title: 'Expert Plumbing Solutions',
  description: 'We use the latest tools and techniques to solve your plumbing issues quickly and effectively, protecting your home.',
  icon: ShieldCheck
}, {
  title: 'Professional Crews',
  description: 'On-time, uniformed, and respectful technicians who treat your property like it was their own.',
  icon: Clock
}, {
  title: 'Upfront Flat-Rate Pricing',
  description: 'No hidden fees or surprise charges. The price we quote is the price you pay, guaranteed.',
  icon: BadgeDollarSign
}, {
  title: 'Satisfaction Guaranteed',
  description: 'We are not finished until you are thrilled with the results. Job done right, every time.',
  icon: ThumbsUp
}];
export function WhyUs() {
  return <section className="py-24 bg-dark relative" data-id="element-256">
      <div className="container mx-auto px-4" data-id="element-257">
        <div className="flex flex-col lg:flex-row gap-16 items-center" data-id="element-258">
          <div className="lg:w-1/2" data-id="element-259">
            <div className="text-left mb-12" data-id="element-260">
              <h2 className="font-display text-4xl md:text-5xl text-white uppercase tracking-wide mb-4" data-id="element-261">
                Why Choose{' '}
                <span className="text-accent" data-id="element-262">Baxter Family Plumbing</span>
              </h2>
              <p className="text-slate-400 text-lg" data-id="element-263">
                We are committed to providing top-tier plumbing services to our
                Texas neighbors, ensuring your home is safe, clean, and
                functioning perfectly.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-8" data-id="element-264">
              {REASONS.map((reason, idx) => <div key={idx} className="flex flex-col items-start text-left relative" data-id="element-265">
                  <div className="h-16 w-16 rounded-full bg-surface border-2 border-accent flex items-center justify-center mb-4 shadow-[0_0_20px_rgba(220,38,38,0.15)]" data-id="element-266">
                    <reason.icon className="h-8 w-8 text-accent" data-id="element-267" />
                  </div>
                  <h3 className="text-xl font-bold text-white mb-2" data-id="element-268">
                    {reason.title}
                  </h3>
                  <p className="text-slate-400 text-sm" data-id="element-269">{reason.description}</p>
                </div>)}
            </div>
          </div>

          <div className="lg:w-1/2 w-full" data-id="element-270">
            <img src="https://images.unsplash.com/photo-1600566752355-35792bedcfea?q=80&w=1000&auto=format&fit=crop" alt="Clean bathroom vanity sink with a modern faucet" className="rounded-2xl shadow-2xl border-2 border-accent/20 w-full h-auto object-cover max-h-[600px]" data-id="element-271" />
          </div>
        </div>
      </div>
    </section>;
}